import { render } from "./TermEdit.vue?vue&type=template&id=690254d4&scoped=true&ts=true"
import script from "./TermEdit.vue?vue&type=script&lang=ts"
export * from "./TermEdit.vue?vue&type=script&lang=ts"

import "./TermEdit.vue?vue&type=style&index=0&id=690254d4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690254d4"]])

export default __exports__